import React from "react";
import { Button, Dialog } from "@cmsgov/ds-medicare-gov";

import { useTranslate, sendTealiumEvent } from "../helpers";

import { AutocompleteDrug } from "../@types";

import { FormattedMessage } from "react-intl-phraseapp";

interface UseGenericDialogProps
  extends Omit<React.ComponentProps<typeof Dialog>, "children"> {
  // brand name drug that has a generic alternative
  brandDrug: AutocompleteDrug;
  onSelectDrug: (selectedDrug: AutocompleteDrug) => void;
}

/**
 * UseGenericDialog is used to prompt the user if they like to use the generic drug.
 */
const UseGenericDialog: React.FunctionComponent<UseGenericDialogProps> = props => {
  const t = useTranslate();

  const brandDrug = props.brandDrug;

  return (
    <Dialog
      headerClassName="UseGenericDialog__promptHeader"
      heading={t("prescription.generic_prompt_header")}
      actions={[
        <Button
          variation="primary"
          key="add-generic-button"
          className="e2e-add-generic-drug-btn"
          onClick={(): void => {
            sendTealiumEvent("Find Plans - Add Drugs", "Add Generic");
            const genericDrug = brandDrug.generic as AutocompleteDrug;
            genericDrug.is_generic = true;
            props.onSelectDrug(genericDrug);
          }}
        >
          {t("prescription.add_generic")}
        </Button>,
        <Button
          key="add-brand-button"
          className="e2e-add-brand-name-drug-btn ds-u-margin-left--2"
          onClick={(): void => {
            sendTealiumEvent("Find Plans - Add Drugs", "Add Brand");
            props.onSelectDrug(brandDrug);
          }}
        >
          {t("prescription.add_brand_instead")}
        </Button>,
      ]}
      {...props}
    >
      <p className="ds-u-margin-top--0 addGeneric__text">
        <FormattedMessage
          id="prescription.generic_available"
          tagName="span"
          values={{
            brand: <strong>{brandDrug.name}</strong>,
            generic: (
              <strong>{(brandDrug as AutocompleteDrug).generic?.name}</strong>
            ),
          }}
        />
      </p>
      <p className="addGeneric__text">
        <FormattedMessage
          id="prescription.add_generic_instead"
          tagName="span"
          values={{
            generic: (
              <strong>{(brandDrug as AutocompleteDrug).generic?.name}</strong>
            ),
          }}
        />
      </p>
    </Dialog>
  );
};

export default UseGenericDialog;
